const progressItemRoles = {
  reviewed: "REVIEWED",
  suspended: "SUSPENDED",
};

export default progressItemRoles;
